import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable notice/warning box component
 * Used across multiple pages for important information
 */
const NoticeBox = ({ 
  type = 'warning', 
  icon = 'ph-info',
  title, 
  message,
  className = '' 
}) => {
  const typeStyles = {
    warning: {
      bg: 'bg-warning-50',
      border: 'border-warning-200',
      iconBg: 'bg-warning-600'
    },
    info: {
      bg: 'bg-info-50',
      border: 'border-info-200',
      iconBg: 'bg-info-600'
    },
    danger: {
      bg: 'bg-danger-50',
      border: 'border-danger-200',
      iconBg: 'bg-danger-600'
    },
    success: {
      bg: 'bg-success-50',
      border: 'border-success-200',
      iconBg: 'bg-success-600'
    }
  };

  const styles = typeStyles[type] || typeStyles.warning;

  return (
    <div className={`${styles.bg} border ${styles.border} p-40 rounded-3 ${className}`}>
      <div className="d-flex align-items-start gap-16">
        <span className={`w-48 h-48 flex-center ${styles.iconBg} text-white rounded-circle flex-shrink-0`}>
          <i className={`ph ${icon} text-xl`} />
        </span>
        <div>
          <h5 className="mb-12">{title}</h5>
          <p className="text-neutral-600 mb-0">{message}</p>
        </div>
      </div>
    </div>
  );
};

NoticeBox.propTypes = {
  type: PropTypes.oneOf(['warning', 'info', 'danger', 'success']),
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default NoticeBox;
